import type { TareAccountStatus } from "../types/TareBridge";

import { getTareBridge } from "./getTareBridge";
import { callPromiseSafely } from "../../util/callPromiseSafely";

/**
 * Load account status from the native module.
 */
export function getAccountStatus(): Promise<TareAccountStatus | null> {
  return callPromiseSafely(getTareBridge()?.getAccountStatus);
}

export function getAccountStatusSync(): TareAccountStatus | null {
  return getTareBridge()?.getAccountStatusSync?.() ?? null;
}
